{
  "version": 1,
  "asset_id": "25b61500-6753-4711-9d20-3345bb1ec1c3",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/25b61500-6753-4711-9d20-3345bb1ec1c3/process-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/25b61500-6753-4711-9d20-3345bb1ec1c3/process-640.webp",
  "original_filename": "process-640.webp",
  "size": 14930,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:38Z"
}
